// extracted by mini-css-extract-plugin
export default {"item":"SearchResult_item__jwWPM","book":"SearchResult_book__Er-Jp","book-data":"SearchResult_book-data__3IWNQ","confirmBtn":"SearchResult_confirmBtn__AuI19"};